import React from 'react';
import { StyledSvgIcon } from '../icon.styles';
import { customIconsPropTypes } from './customicons.propTypes';

const DirectionCarIcon = ({ fontSize, color, sx, title }) => (
  <StyledSvgIcon
    fontSize={fontSize}
    color={color}
    titleAccess={title}
    data-testid={title}
    aria-label={title}
    sx={sx}
  >
    <svg viewBox="0 0 123 110" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.6667 41.25L23.9167 10.3125H99.0833L109.333 41.25M99.0833 75.625C96.3649 75.625 93.7577 74.5385 91.8355 72.6045C89.9132 70.6706 88.8333 68.0475 88.8333 65.3125C88.8333 62.5775 89.9132 59.9544 91.8355 58.0205C93.7577 56.0865 96.3649 55 99.0833 55C101.802 55 104.409 56.0865 106.331 58.0205C108.253 59.9544 109.333 62.5775 109.333 65.3125C109.333 68.0475 108.253 70.6706 106.331 72.6045C104.409 74.5385 101.802 75.625 99.0833 75.625ZM23.9167 75.625C21.1982 75.625 18.5911 74.5385 16.6688 72.6045C14.7466 70.6706 13.6667 68.0475 13.6667 65.3125C13.6667 62.5775 14.7466 59.9544 16.6688 58.0205C18.5911 56.0865 21.1982 55 23.9167 55C26.6351 55 29.2423 56.0865 31.1645 58.0205C33.0868 59.9544 34.1667 62.5775 34.1667 65.3125C34.1667 68.0475 33.0868 70.6706 31.1645 72.6045C29.2423 74.5385 26.6351 75.625 23.9167 75.625ZM108.787 6.875C107.42 2.8875 103.593 0 99.0833 0H23.9167C19.4067 0 15.58 2.8875 14.2133 6.875L0 48.125V103.125C0 104.948 0.719938 106.697 2.00144 107.986C3.28294 109.276 5.02102 110 6.83333 110H13.6667C15.479 110 17.2171 109.276 18.4986 107.986C19.7801 106.697 20.5 104.948 20.5 103.125V96.25H102.5V103.125C102.5 104.948 103.22 106.697 104.501 107.986C105.783 109.276 107.521 110 109.333 110H116.167C117.979 110 119.717 109.276 120.999 107.986C122.28 106.697 123 104.948 123 103.125V48.125L108.787 6.875Z"
        fill="currentColor"
      />
    </svg>
  </StyledSvgIcon>
);
export default DirectionCarIcon;

DirectionCarIcon.propTypes = customIconsPropTypes;
